import { useState, useEffect } from 'react';

export const useServiceWorkerVersion = () => {
  const [version, setVersion] = useState<string | null>(null);

  useEffect(() => {
    // Listen for service worker updates
    const handleSWMessage = (event: MessageEvent) => {
      if (event.data?.type === 'SW_UPDATED' && event.data?.version) {
        setVersion(event.data.version);
      }
    };

    // Simple approach: extract version from service worker file
    const getVersionFromSW = async () => {
      try {
        // Fetch the service worker file to extract version
        const response = await fetch('/sw.js');
        const swContent = await response.text();
        
        // Extract version from the VERSION constant
        const versionMatch = swContent.match(/const VERSION = '([^']+)'/);
        if (versionMatch) {
          setVersion(versionMatch[1]);
          return;
        }
      } catch (error) {
        console.warn('Could not fetch service worker version:', error);
      }

      // Fallback: use current date
      const now = new Date();
      const dateStr = now.getFullYear() + '-' + 
                     String(now.getMonth() + 1).padStart(2, '0') + '-' + 
                     String(now.getDate()).padStart(2, '0');
      setVersion(dateStr);
    };

    // Listen for service worker messages
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.addEventListener('message', handleSWMessage);
    }
    
    // Get initial version
    getVersionFromSW();

    return () => {
      if ('serviceWorker' in navigator) {
        navigator.serviceWorker.removeEventListener('message', handleSWMessage);
      }
    };
  }, []);

  return version;
};